module.exports = __webpack_public_path__ + "static/img/finance.b24ec6e6.jpg";